
// const MAX_ARTICLES = 20;
// const STR_ROOT     = "https://core.healthandher.com/symptom-tool";
// const LOOKUP_ROOT_BASE  = "https://core.healthandher.com/app/lookup/symptom";
// if ( window.market != 'gb' ) {
//     var LOOKUP_ROOT  = LOOKUP_ROOT_BASE + "?lang="+window.market;
// } else {
//     var LOOKUP_ROOT  = LOOKUP_ROOT_BASE;
// }

function SendAPIRequest( url, method, payload, cb )
{
    if ( url ) {
        var xhr = new XMLHttpRequest( );

        xhr.onreadystatechange = function( )
        {
            if ( xhr.readyState == 4 )
            {
                var response;
                var err;
                if ( xhr.status == 200 )
                {
                    if ( ( xhr.responseText ) && ( xhr.responseText.length > 0 ) )
                    {
                        var ct = xhr.getResponseHeader( "content-type" );
                        
                        if ( ct.startsWith( "application/json" ) )
                        {
                            try
                            {
                                response = JSON.parse( xhr.responseText );
                            }
                            catch ( e )
                            {
                                console.log( "error parsing response : " + e.stack );
                                err = { "error" : e };
                            }
                        }
                        else
                        {
                            err = { "error" : "invalid content type received : " + ct };
                            response = xhr.responseText;
                        }
                    }
                    cb( err, response, xhr );
                }
                else if ( xhr.status == 429 )
                {
                    setTimeout( function( )
                    {
                        SendAPIRequest( url, method, payload, cb );
                    }, 2000 );
                }
                else
                {
                    err = { "error" : xhr.status };

                    if ( ( xhr.responseText ) && ( xhr.responseText.length > 0 ) )
                    {
                        try
                        {
                            err.detail = JSON.parse( xhr.responseText );
                        }
                        catch ( e )
                        {
                        }
                    }
                    cb( err, response, xhr );
                }
            }
        };

        if ( ( method != "GET" ) && ( payload ) )
        {
            xhr.open( method, url, true );
            //xhr.setRequestHeader( "x-store", Shopify.shop );
            xhr.setRequestHeader( "Content-Type", "application/json" );
            xhr.send( JSON.stringify( payload ) );
        }
        else
        {
            if ( payload )
            {
                var qpStr = "?";
                for ( var key in payload )
                {
                    if ( qpStr.length > 1 )
                    {
                        qpStr += "&";
                    }
                    qpStr += key + "=" + encodeURIComponent( payload[ key ] );
                }
                xhr.open( method, url, true );
            }
            else
            {
                xhr.open( method, url, true );
            }

            //xhr.setRequestHeader( "x-store", Shopify.shop );
            xhr.send( );
        }
    }
}


function CreateProductCard( product, isSwiper )
{
    var card = document.createElement( "div" );

    if(isSwiper)
    {      
        card.classList = ["swiper-slide"];
    }
    else
    {
        card.classList = ["width-third"];
    }

    card.innerHTML = product.card;
    // `
    //         <div class="card card--standard symptom-product-card" style="--ratio-percent: 100%;">
    //             <div class="card__media symptom-product-card-image-wrapper">
    //                 <div class="media media--transparent media--hover-effect">
    //                     <img loading="lazy" src="${product.image}" width="200" height="200" class="motion-reduce" alt="">
    //                 </div>
    //             </div>
    //             <div class="card__content symptom-product-card-content-container">
    //                 <a href="/products/${product.handle}" class="full-unstyled-link">
    //                     <h3 class="card__heading h5 symptom-product-card-title">${product.title}</h3>
    //                 </a>
    //                 <div class="card-information">
    //                     <div class="symptom-product-card-stars">
    //                         ${product.judgeme}
    //                     </div>
    //                     <div class="price symptom-product-card-price-container">
    //                         ${product.price}
    //                     </div>
    //                 </div>
    //             </div>
    //         </div>

    // `;

    return ( card );
}

function ArticleURL( article )
{
  var url = article.url;
  if ( !url )
  {
    url = `/blogs/${article.blog.handle}/${article.handle}`;
  }
  return ( url );
}
function ArticleImageURL( article )
{
  var url = article.image;
  if ( url )
  {
    url += "&width=800";
  }
  else
  {
    url = article.image_url;
  }
  return ( url );
}

function CreateAdviceCard( article )
{
    var card = document.createElement( "div" );
    card.classList.add( "article_details_box" );
    // var article_excerpt = article.body_html_safe.split(" ").splice(0,20).join(" ") + " ...";
    // var article_excerpt = article.body_html_safe;
    // card.innerHTML =
    // `
    //     <a href="${ArticleURL(article)}" class="article_lnk">
    //         <div class="article_details_box_inner">
    //             <img loading="lazy" class="article_image" src="${ArticleImageURL(article)}" width="400" height="auto" alt="">
    //             <div class="author_details_wrapper"></div>
    //             <div class="article_content">
    //                 <h3 class="article_title">${article.title}</h3>
    //                 <div class="article_excerpt">${article_excerpt}</div>
    //                 <div class="article_button"> Read article</div>
    //             </div>
    //         </div>
    //     </a>
    // `;
    article.body_html_safe = article.card.replace("article_details_box", "article_details_box__inner"); 
    card.innerHTML = article.body_html_safe;
    
    return ( card );
}

function AddHeroAdvice( articles, stage )
{
    var wrapper = document.getElementById( "hh-symptom-results-hero-row" );
    wrapper.classList.add( "expert_advice_section" );
    var target = wrapper.querySelector( "div" );
    target.classList.add( "all_article_details" );
    var extraBlock = wrapper.querySelector( ".hero-extra-container" );
    if( extraBlock )
    {
        extraBlock.classList.remove( "hidden" );
    }
    if( window.Shopify.routes.root != "/" )
    {
        var max = articles.length > 1 ? 3 : articles.length;
        articles.splice( 0, 1 );
    }
    else
    {
        var max = articles.length > 1 ? 2 : articles.length;
        articles.splice( 0, 0 );
    }

    for ( var i = 0; i < max; i++ )
    {
        if( stage.includes( "meno" ) || stage.includes( "post" ) )
        {
            if( articles[ i ].tags.includes( "symptom__results_exclude:perimenopause" ) == false )
            {
                target.insertBefore( CreateAdviceCard( articles[ i ] ), target.lastElementChild );
            }
        }
        else
        {
            target.insertBefore( CreateAdviceCard( articles[ i ] ), target.lastElementChild );
        }
    }

    // hide advice title and summary, make it look like one advice block..
    document.querySelector( "#hh-symptom-results-article-container h2" ).classList.add( "hidden" );
    document.querySelectorAll( "#hh-symptom-results-article-container div.section-text" ).forEach((item, index)=>{
        item.classList.add( "hidden" );
    })
    if ( el = document.querySelector( ".hh-symptom-results-app-container" ) ) {
        el.style.marginBottom = "24px";
    }
    
}

function AddMainAdvice( articles, stage )
{
    var wrapper = document.getElementById( "hh-symptom-results-article-container" );
    var initialTarget = wrapper.querySelector( ".hh-symptom-articles-initial-container" );
    var showMoreTarget = wrapper.querySelector( ".hh-symptom-articles-more-container" );
    var target = initialTarget;

    wrapper.classList.add( "expert_advice_section" );
    initialTarget.classList.add( "all_article_details" );
    showMoreTarget.classList.add( "all_article_details" );

    var counter = 1;
    var max = articles.length > 8 ? 9 : articles.length;

    for ( var i = 0; i < articles.length; i++ )
    {
        if( counter <= max )
        {
            if( i <= 2 )
            {
                target = initialTarget;
            }
            else
            {
                target = showMoreTarget;
            }
            if( stage.includes( "meno" ) || stage.includes( "post" ) )
            {
                if( ( articles[ i ].tags ) && ( articles[ i ].tags.includes( "symptom_results_exclude:perimenopause" ) ) )
                {
                  
                }
                else
                {
                    target.appendChild( CreateAdviceCard( articles[ i ] ) );
                    counter++;
                }
            }
            else
            {
                target.appendChild( CreateAdviceCard( articles[ i ] ) );
                counter++;
            }
        }
    }
    var viewMoreDiv = document.createElement( "div" );
    viewMoreDiv.classList.add( "hh-symptom-view-more-button-wrapper" );
    var viewMoreBtn = document.createElement( "a" );
    viewMoreBtn.setAttribute( "class", "button button-primary" );
    viewMoreBtn.setAttribute( "href", window.Shopify.routes.root + "blogs/expert-advice" );
    viewMoreBtn.textContent = "View more expert advice";
    viewMoreDiv.appendChild( viewMoreBtn );

    if ( showMoreTarget )
    {
        showMoreTarget.appendChild( viewMoreDiv );
    }

    wrapper.classList.remove( "hidden" );
}

function AddHeroProducts( stage )
{
    var wrapper = document.getElementById( "hh-symptom-results-hero-row" );
    wrapper.classList.add( "hero-products" );
    var target = wrapper.querySelector( "div" );
    target.classList.add( "all_article_details" );
    var extraBlock = wrapper.querySelector( ".hero-extra-container" );
    var counter = 0;
    for ( var i = 0; i < g_stageProducts.length; i++ )
    {
        if ( g_stageProducts[ i ].stage == stage && g_stageProducts[ i ].pid != "" )
            {
                if (window.brand == 'him' && window.improvements.length) {
                    if ( 
                        ( g_stageProducts[ i ].title.indexOf('Desire') > 0 && !improvements.includes('sexual-desire') )
                        ||
                        (g_stageProducts[ i ].title.indexOf('Night') > 0 && !improvements.includes('normal-sleep') )
                    ) {
                        continue;
                    }
                } 
            target.insertBefore( CreateProductCard( g_stageProducts[ i ], false ), extraBlock );
            counter++;
            if( extraBlock )
            {
                if ( counter > 0 )
                {
                    extraBlock.classList.remove( "hidden" );
                    // break;
                }
            // } else
            // {
            //     if ( counter > 20 )
            //     {
            //         // break;
            //     }
            }
        }
    }
}

function AddMainProducts( results, stage )
{
    var wrapper = document.getElementById( "hh-symptom-results-products-container" );
    wrapper.classList.add( "expert_advice_section" );
    var target  = document.querySelector( "#hh-symptom-results-products-container .swiper-wrapper" );
    var products = window.g_MoreProductLookup[stage];
    max_items = 4;
    var count = 0;
    for (let product in products) {

        if (window.brand == 'him' && window.improvements.length) {
            // remove night or desire single products, as already included in hero products
            if ( products[product].title.indexOf('Bundle') === -1 ) {
                if ( 
                    ( products[product].title.indexOf('Desire') > 0  && improvements.includes('sexual-desire') )
                    ||
                    ( products[product].title.indexOf('Night') > 0 && improvements.includes('normal-sleep') )
                ) {
                    continue;
                }
            }
        }

        target.appendChild( CreateProductCard(products[product], true) );
        count++;
        if (count == max_items) break;
    }
    wrapper.classList.remove( "hidden" );
}

function ReallyBuildResultDOM( results, lookups, articles, stage, cb )
{
    //console.log('== ReallyBuildResultDOM');
    var interestedIn = results.Item.data.interests;
    // var stage        = results.Item.data.stage ? results.Item.data.stage : "unsure";
    
    // var headline_info = document.querySelector( ".main-page-content-header" );
    // headline_info.querySelector( ".stage-"+stage ).classList.remove('hidden')
    // var headline_info = document.querySelector( ".main-page-content-header" );
    // show appropriate text from blocks
    document.querySelectorAll( ".hidden.stage-"+stage ).forEach(function (el, index) {
        el.classList.remove('hidden');
    });
    
    // console.log(window.g_articles);
    if ( interestedIn.includes( "products" ) )
    {
        // headline_info.textContent = headline_info.dataset.productsText;
        AddHeroProducts( stage );
        AddMainProducts( results, stage );
    }
    else
    {
        
        document.querySelector('#hh-symptom-results-products-container').classList.add('hidden');
        // headline_info.textContent = headline_info.dataset.adviceText;
        AddHeroAdvice( window.g_articles, stage );

        if( window.Shopify.routes.root != "/" ) {
            window.g_articles = window.g_articles.slice(3);
        } else {
            window.g_articles = window.g_articles.slice(2);
        }

    }

    if ( interestedIn.includes( "advice" ) || interestedIn.includes( "advice & guidance" ) )
    {
        // headline_info.textContent = headline_info.dataset.adviceText;
        // articles.slice( 2 );
        // console.log(window.g_articles.length);
        AddMainAdvice( window.g_articles, stage );
    }

    var viewMoreElements = document.querySelectorAll( "[data-show-more-target]" );
    viewMoreElements.forEach( function( element )
    {
        element.addEventListener( "click",  function( e )
        {
            document.querySelector( "[data-show-more-id='" + element.dataset.showMoreTarget + "']" ).classList.remove( "hidden" );
            element.classList.add( "hidden" );
        });
    } );

    cb();
}

function GetCookie( cname )
{
    var name          = cname + "=";
    var decodedCookie = decodeURIComponent( document.cookie );
    var ca            = decodedCookie.split( ';' );

    for ( var i = 0; i < ca.length; i++ )
    {
        var c = ca[ i ];
        while ( c.charAt( 0 ) == ' ' ) 
        {
            c = c.substring( 1 );
        }
        if ( c.indexOf( name ) == 0 ) 
        {
            return c.substring( name.length, c.length );
        }
    }
    return ( "" );
}
function SetCookie( name, value, durationMS )
{
    if ( !durationMS )
    {
        const ONE_DAY_IN_MS = ( 24 * 60 * 60 * 1000 );
        durationMS = ONE_DAY_IN_MS * 365;
    }

    var now = new Date( ).getTime( );
    var exp = new Date( now + durationMS );
    document.cookie = name + "=" + value + ";path=/;expires=" + exp.toUTCString( );
}

// function GetArticlesFromShopifySearch( payload, cb )
// {
//     // console.log( "get articles from shopify...")
//     var url = window.Shopify.routes.root + "search/suggest.json?section_id=predictive_search&resources[type]=article&q=";

//     for ( var i = 0; i < payload.requests.length; i++)
//     {
//         var request = payload.requests[ i ];

//         if ( i > 0 )
//         {
//           url += " OR ";
//         }
//         url += "'" + request.query + "'";
//     }

//     SendAPIRequest( url, "GET", null, function( err, data )
//     {
//         if ( ( data ) && ( data.resources ) && ( data.resources.results ) && ( data.resources.results.articles ) )
//         {
//            var list   = data.resources.results.articles;
//            var result = { "hits" : [ ] };

//            list.forEach( function( hit )
//            {
//                 var shouldAdd = false;

//                 var summary = hit.summary_html;
//                 if ( summary && summary.length == 0 )
//                 {
//                     summary.trim( );
//                     summary = hit.body.substr( 0, 200 );
//                 }

//                 if ( summary && summary.length > 0 )
//                 {
//                      if ( window.Shopify.routes.root == "/en-us/" )
//                      {
//                         if ( hit.tags.includes( "us") )
//                         {
//                           shouldAdd = true;
//                         }
//                      }
//                      else
//                      {
//                         if ( !( hit.tags.includes( "us") ) )
//                         {
//                           shouldAdd = true;
//                         }                       
//                      }
//                 }

//              if ( shouldAdd )
//              {
//                 var add =
//                 {
//                   "title" : hit.title,
//                   "body_html_safe" : hit.body,
//                   "url" : hit.url,
//                   "image" : hit.featured_image.url,
//                   "article_excerpt" : hit.summary_html
//                 };
//                 result.hits.push( add );                    
//              }
//             } );
//             cb( err, { "results" : [ result ] } );
//         }
//     } );
// }

function GetArticlesFromDOM( payload, cb )
{
    if ( window.brand == 'him' ) {
        var includeAll = true;
    }
    var result = { "hits" : [ ] };
    var tags = window.symptoms;

    window.g_articles.forEach( function( hit )
    {
        var include = 0;
        var article_tags = Array.from(JSON.parse(hit.tags.toLowerCase()));
        tags.forEach(tag => {
            if ( includeAll == true || article_tags.includes(tag.toLowerCase()) ) {
                include = 1;
                // } else if ( article_tags.length == 0 ) {
            //     console.log('... no tags, include');
            //     include = 1;
            }
        });
        if (include){
            //console.log('== ' + hit.title);
            var add =
            {
                "title" : hit.title,
                "body_html_safe" : hit.card,
                "url" : hit.url,
                "image" : hit.image,
                "article_excerpt" : hit.excerpt
            };
            result.hits.push( add );    
        }
    });
    // console.log('result.hits.length = '+result.hits.length);
    cb( null, { "results" : [ result ] } );
}

function GetArticles( payload, cb )
{
    // var url = SEARCH_URL;
    //if ( GetCookie( "str_shopify") )
    if ( true )
    {
    //   GetArticlesFromShopifySearch( payload, cb );
    GetArticlesFromDOM( payload, cb )
    }
    else if ( window.Shopify.routes.root == "/en-us/" )
    {
        url = SEARCH_URL_US;

        var asyncs = 1;
      
        var result = { "hits" : [ ] };

        function Done( err, data )
        {
          asyncs--;

          if ( ( data ) && ( data.hits ) )
          {
            data.hits.forEach( function( hit )
            {
                var add =
                {
                  "title" : hit.post_title,
                  "body_html_safe" : hit.content,
                  "url" : hit.permalink,
                  "image_url" : hit.images.medium.url,
                  "article_excerpt" : hit.content.substr(1000)
                };
                result.hits.push( add );                    
            } );
          }

          if ( asyncs == 0 )
          {
            cb( err, { "results" : [ result ] } );
          }
        }

        payload.requests.forEach( function( request )
        {
            var usPayload =
              {
                "query" : request.query,
                "hitsPerPage" : 4,
                "filters" : "language:us"
              };
            asyncs++;
            SendAPIRequest( url, "POST", usPayload, Done );
        } );

        Done( );
    }
    else
    {
        SendAPIRequest( url, "POST", payload, cb );
    }
}

function LookupArticles( results, lookups, cb )
{
    var asyncs = 1;
    function Done( )
    {
        asyncs--;
        if ( asyncs == 0 )
        {
        }
    }
    
    if ( window.brand == 'him' ) {
        var lookup = [];
        lookups.lookup_item.forEach( function( symptom )
            {
                var tmp = JSON.parse(symptom.name);
                lookup[symptom.id] = tmp[0].value.text;
            } );

        var symptoms = [];
        var payload = { "requests" : [ ] };
        Object.keys(results.Item.data.symptoms).map((key) => {
            window.symptoms.push(lookup[key]);
            var request =
            {
                "indexName" : "shopify_articles",
                "query"     : lookup[key],
                "params"    : "hitsPerPage="
            };
            payload.requests.push( request );
        });

    } else {
        
        
        var symptomsByDDBID = { };
        lookups.Symptom.forEach( function( symptom )
        {
            // console.log('symptomsByDDBID');
            symptomsByDDBID[ symptom.id ] = symptom.name;
        } );
        var payload = { "requests" : [ ] };
        for ( var symptomID in results.Item.data.symptoms )
        {

            if ( term = symptomsByDDBID[ symptomID ] )
            {
                var request =
                {
                    "indexName" : "shopify_articles",
                    "query"     : term,
                    "params"    : "hitsPerPage="
                };
                payload.requests.push( request );
                window.symptoms.push(term);
            }
            else
            {
                console.log( "ERROR - unknown symptom " + symptomID );
            }
            
        }
    }


    
        if ( payload.requests.length > 0 )
        {
            // var qty = Math.ceil( MAX_ARTICLES / payload.requests.length ) + 2;  // hacktastic !
            // console.log(qty);
            // payload.requests.forEach( function( request )
            // {
            //     request.params += qty;
            // } );
            // console.log(request.params);
            asyncs++;
            GetArticles( payload, function( err, data )
            {
                var articles = [ ];
                var articleCheck = [ ];
                
                if ( ( data ) && ( data.results ) )
                {
                    data.results.forEach( function( result )
                    {
                        if ( result.hits )
                        {
                            result.hits.forEach( function( hit )
                            {
                                if( !articleCheck.includes( hit.title ) )
                                {
                                    //console.log('---> ' + hit.title);

                                    articleCheck.push( hit.title );
                                    articles.push( hit );
                                }
                            } );
                        }
                    } );
                }
                cb( articles );
            } );
        }

        Done( );
    
}

function LookupArticles_OLD( results, lookups, cb )
{
    var asyncs = 1;
    function Done( )
    {
        asyncs--;
        if ( asyncs == 0 )
        {
        }
    }

    var symptomsByDDBID = { };
    lookups.Symptom.forEach( function( symptom )
    {
        symptomsByDDBID[ symptom.id ] = symptom.name;
    } );
    var payload = { "requests" : [ ] };
    for ( var symptomID in results.Item.data.symptoms )
    {

        if ( term = symptomsByDDBID[ symptomID ] )
        {
            var request =
            {
                "indexName" : "shopify_articles",
                "query"     : term,
                "params"    : "hitsPerPage="
            };
            payload.requests.push( request );
            window.symptoms.push(term);
        }
        else
        {
            console.log( "ERROR - unknown symptom " + symptomID );
        }
        
    }

    if ( payload.requests.length > 0 )
    {
        // var qty = Math.ceil( MAX_ARTICLES / payload.requests.length ) + 2;  // hacktastic !
        // console.log(qty);
        // payload.requests.forEach( function( request )
        // {
        //     request.params += qty;
        // } );
        // console.log(request.params);
        asyncs++;
        GetArticles( payload, function( err, data )
        {
            var articles = [ ];
            var articleCheck = [ ];
            
            if ( ( data ) && ( data.results ) )
            {
                data.results.forEach( function( result )
                {
                    if ( result.hits )
                    {
                        result.hits.forEach( function( hit )
                        {
                            if( !articleCheck.includes( hit.title ) )
                            {
                                // console.log('---> ' + hit.title);

                                articleCheck.push( hit.title );
                                articles.push( hit );
                            }
                        } );
                    }
                } );
            }
            cb( articles );
        } );
    }

    Done( );
}

function HandleProductATC()
{
    if (!customElements.get('product-form'))
    {
        customElements.define(
        'product-form',
        class ProductForm extends HTMLElement
        {
            constructor()
            {
                super();
        
                this.form = this.querySelector('form');
                this.form.querySelector('[name=id]').disabled = false;
                this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
                this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
                this.submitButton = this.querySelector('[type="submit"]');
        
                if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
        
                this.hideErrors = this.dataset.hideErrors === 'true';
            }
    
            onSubmitHandler(evt)
            {
                evt.preventDefault();
                if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        
                this.handleErrorMessage();
        
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.classList.add('loading');
                this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        
                const config = fetchConfig('javascript');
                config.headers['X-Requested-With'] = 'XMLHttpRequest';
                delete config.headers['Content-Type'];
        
                const formData = new FormData(this.form);
                if (this.cart) 
                {
                    formData.append(
                    'sections',
                    this.cart.getSectionsToRender().map((section) => section.id)
                    );
                    formData.append('sections_url', window.location.pathname);
                    this.cart.setActiveElement(document.activeElement);
                }
                config.body = formData;
    
                fetch(`${routes.cart_add_url}`, config)
                .then((response) => response.json())
                .then((response) => {
                if (response.status)
                {
                    publish(PUB_SUB_EVENTS.cartError,
                    {
                        source: 'product-form',
                        productVariantId: formData.get('id'),
                        errors: response.errors || response.description,
                        message: response.message,
                    });
                    this.handleErrorMessage(response.description);
    
                    const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                    if (!soldOutMessage) return;
                    this.submitButton.setAttribute('aria-disabled', true);
                    this.submitButton.querySelector('span').classList.add('hidden');
                    soldOutMessage.classList.remove('hidden');
                    this.error = true;
                    return;
                } 
                else if (!this.cart)
                {
                    window.location = window.routes.cart_url;
                    return;
                }
    
                if (!this.error)
                    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
                this.error = false;
                const quickAddModal = this.closest('quick-add-modal');
                if (quickAddModal)
                {
                    document.body.addEventListener(
                    'modalClosed',
                    () => {
                        setTimeout(() => {
                        this.cart.renderContents(response);
                        });
                    },
                    { once: true }
                    );
                    quickAddModal.hide(true);
                }
                else
                {
                    this.cart.renderContents(response);
                }
                })
                .catch((e) => {
                console.error(e);
                })
                .finally(() => {
                this.submitButton.classList.remove('loading');
                if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                this.querySelector('.loading-overlay__spinner').classList.add('hidden');
                });
            }
    
            handleErrorMessage(errorMessage = false)
            {
                if (this.hideErrors) return;
        
                this.errorMessageWrapper =
                    this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
                if (!this.errorMessageWrapper) return;
                this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        
                this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        
                if (errorMessage)
                {
                    this.errorMessage.textContent = errorMessage;
                }
            }
        });
    }
}

function BuildResultDOM( results, lookups )
{
    // console.log('== BuildResultDOM');

    var interestedIn = results.Item.data.interests;
    if ( window.brand == 'him' ) {
        if ( results.Item.data.age < 55 ) {
            results.Item.data.stage = '40';
        } else {
            results.Item.data.stage = '55';
        }
        window.improvements = Object.keys(results.Item.data.improvements);
    }



    var stage = results.Item.data.stage ? results.Item.data.stage : "unsure";

    if ( interestedIn.includes( "advice" ) )
    {
        LookupArticles( results, lookups, function( articles )
        {
            ReallyBuildResultDOM( results, lookups, articles, stage, function()
            {
                const swiper = new Swiper('.product-swiper', {
                    slidesPerView: 1.2,
                    spaceBetween: 5,
                    loop: false,
                    centeredSlides: false,
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true,
                    },
                    breakpoints: {
                        768: {
                        slidesPerView: 4,
                        spaceBetween: 30,
                        }
                    }
                });
                document.querySelector('.loader').classList.add( "hidden" );
                HandleProductATC();
            });
        } );
    }
    else
    {
        // no need to wait, it's products only
        ReallyBuildResultDOM( results, lookups, [ ], stage, function(){
            const swiper = new Swiper('.product-swiper', {
                slidesPerView: 1.2,
                spaceBetween: 5,
                loop: false,
                centeredSlides: false,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                breakpoints: {
                    768: {
                        slidesPerView: 4,
                        spaceBetween: 30,
                        }
                }
            })
            document.querySelector('.loader').classList.add( "hidden" );
            HandleProductATC();
        } );
    }
}



function DOMLoaded( )
{
    window._domLoaded = true;

    if ( window._domLoadQ )
    {
        window._domLoadQ.forEach( function ( fn )
        {
            fn( );
        } );
    }
}
window.addEventListener( "load", DOMLoaded );

function WhenDOMLoaded( cb )
{
    if ( window._domLoaded )
    {
        cb( );
    }
    else
    {
        if ( window._domLoadQ == undefined )
        {
            window._domLoadQ = [ ];
        }
        window._domLoadQ.push( cb );
    }
}


function DOMApply( root, selector, op )
{
    var elements = root.querySelectorAll( selector );
    elements.forEach( function( element )
    {
        op( element );
    } );
}

function ParseQPStr( str )
{
    var qpd   = { };
    var qp    = str.substr( 1 );
    var pairs = qp.split( "&" );

    for ( var i = 0; i < pairs.length; i++ )
    {
        var tuple = pairs[ i ].split( "=" );
        if ( ( tuple ) && ( tuple.length == 2 ) )
        {
            var key  = tuple[ 0 ];
            var val  = tuple[ 1 ];
            qpd[ key ] = decodeURIComponent( val );
        }
    }

    return ( qpd );
}
function ParseQP( )
{
    return ( ParseQPStr( window.location.search ) );
}

function StartupSTR( )
{
    var qp = ParseQP( );

    if ( ( Shopify.designMode ) && ( !qp.id ) )
    {
        // running in the theme customiser, use a dummy set of results
        if ( window.brand == 'him' ) {
            qp.id = "f6ffbab4-ae5e-4c84-a0ff-1bd32f0b8b5d&x";
        } else {
            qp.id = "be408a8e-4c1e-461a-ae53-310b2090747f";
        }
    }
    
    if ( qp.id )
    {
        var asyncs = 2;
        var results;
        var lookups;
        function Done( )
        {
            asyncs--;
            if ( asyncs == 0 )
            {
                WhenDOMLoaded( function( )
                {
                    BuildResultDOM( results, lookups );
                } );
            }
        }
        
        SendAPIRequest( window.str_root + "&id=" + qp.id, "GET", null, function( err, data )
        {
            if ( data )
            {
                results = data;
                Done( );
            }
        } );
        SendAPIRequest( window.lookup_root, "GET", null, function( err, data )
        {
            if ( data )
            {
                lookups = data;
                Done( );
            }
        } );
    }
    else
    {
        window.location = "/pages/symptom-tool-steps";
    }
}
StartupSTR( );
